import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MeetingAttendeesPartialState, MEETINGATTENDEES_FEATURE_KEY, State } from './meeting-attendees.reducer';

// Lookup the 'MeetingAttendees' feature state managed by NgRx
export const getMeetingAttendeesState = createFeatureSelector<MeetingAttendeesPartialState,
  State
>(MEETINGATTENDEES_FEATURE_KEY);

export const getMeetingLoaded = createSelector(
  getMeetingAttendeesState,
  (state: State) => state.loaded
);

export const getMeetingError = createSelector(
  getMeetingAttendeesState,
  (state: State) => state.error
);

export const getMeeting = createSelector(
  getMeetingAttendeesState,
  (state: State) => state.meeting
);

export const getMeetingId = createSelector(
  getMeetingAttendeesState,
  (state: State) => state.meeting?.id
);

export const getEmail = createSelector(
  getMeetingAttendeesState,
  (state: State) => state.email
);